// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"e6953c65","569":"15edf4c8"}[chunkId] + ".chunk.js";
};